import { ActionTypes } from "../constants/action-types"

const initialState = {
  eventByStatus: []
}

const GetEventByStatus = (state=initialState, {type, payload})=>{
    switch(type){
        case ActionTypes.GET_EVENT_BY_STATUS : return {...state, 
            eventByStatus: payload}           
        default: return state;
    }
    
}


export default GetEventByStatus;